import React from "react"
import {Tooltip, Typography} from "@mui/material"

import {useNotification} from "@indebted/components/Notification"
import {colors} from "@indebted/theme/colors"

// The line copies itself rather than carrying a button: an icon sized for a
// caption still outweighs it, and the value is the target an agent is already
// pointing at.
function CopyableCaption({
	value,
	label,
	ariaLabel,
	copiedNotice,
}: {
	value: string
	label: string
	ariaLabel: string
	copiedNotice: string
}) {
	const {notification} = useNotification()

	const copy = () => {
		navigator.clipboard
			.writeText(value)
			.then(() => notification.success(copiedNotice))
			.catch(() => notification.error("Failed to copy to clipboard. Please manually copy the content."))
	}

	return (
		<Tooltip title="Click to copy" placement="top">
			<Typography
				component="button"
				type="button"
				variant="caption"
				onClick={copy}
				aria-label={ariaLabel}
				sx={{
					alignSelf: "flex-start",
					p: 0,
					border: "none",
					background: "none",
					textAlign: "left",
					cursor: "pointer",
					color: colors.gray["500"],
					wordBreak: "break-all",
					"&:hover": {color: colors.gray["700"], textDecoration: "underline"},
				}}
			>
				{label}
			</Typography>
		</Tooltip>
	)
}

export {CopyableCaption}
